












import { defineComponent } from '~/utils/nuxt3-migration'
export default defineComponent({
  props: {
    tag: { type: String, default: 'div' },
    fluid: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false }
  },
  setup() {
    return {}
  }
})
